<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('simDistribute.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('simDistribute.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="d-flex ts-items-center ts-space-x-3">
            <ts-button
              outline
              color="info"
              @click.prevent="vieMap"
              :waiting="loadingView"
            >
              {{ $t('simDistribute.viewLocation') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData"
            />
          </div>
          <div class="d-flex ts-items-center ts-space-x-3">
            <a-select
              style="width: 257px"
              v-model="branch_id"
              :options="branchs"
              showSearch
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="1"
              :maxTagTextLength="17"
              :placeholder="$t('simDistribute.allBranchs')"
              @change="changeBranch()"
            >
            </a-select>
            <a-select
              style="width: 257px"
              v-model="location_id"
              :options="locations"
              showSearch
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="1"
              :maxTagTextLength="17"
              :placeholder="$t('simDistribute.allLocations')"
            >
            </a-select>
            <ts-input
              v-tooltip="$t('simDistribute.search')"
              v-model="search"
              :placeholder="$t('simDistribute.searchPlaceHolder')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'branch_name_en'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.location_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.serial_no }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.imei }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.id_type }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.id_number }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.id_name }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.id_sex }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.address }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.gis_location
                  ? record.gis_location.lat + ',' + record.gis_location.lng
                  : 'N/A'
              }}
            </td>
            <td class="ts-whitespace-no-wrap">
              <a
                href="#"
                @click.prevent="onShowImage(record)"
                v-if="record.photo"
              >
                <Icon type="md-images" size="25" />
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <a-modal
        v-if="show_map"
        v-model="show_map"
        :title="$t('visitation.viewMap')"
        centered
        :zIndex="1020"
        :footer="null"
        :maskClosable="false"
        wrap-class-name="full-modal"
        width="100%"
      >
        <VieMap :record="recordData" />
      </a-modal>
    </ts-card>
    <div
      v-if="showImage"
      class="ts-w-full ts-h-screen ts-absolute ts-top-0 ts-left-0 ts-flex ts-items-center ts-justify-center"
      style="
        z-index: 1024;
        background: rgba(53, 53, 53, 0.692);
        backdrop-filter: blur(10px);
      "
    >
      <div
        class="ts-h-64 ts-rounded-md ts-p-4 ts-relative"
        style="width: 500px"
      >
        <button
          @click.prevent="showImage = false"
          class="focus:ts-outline-none ts--mt-2 ts--mr-2 ts-bg-red-700 ts-h-6 ts-w-6 ts-rounded-full ts-flex ts-items-center ts-justify-center ts-text-white ts-font-bold hover:ts-bg-gray-600 ts-transition-all ts-duration-200 ts-absolute ts-top-0 ts-right-0"
        >
          <i class="fas fa-times"></i>
        </button>
        <img
          :src="image"
          alt=""
          class="ts-w-full ts-h-full ts-object-contain ts-rounded-md ts-border ts-border-white"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import VieMap from './components/view-map.vue'

export default {
  name: 'simDistribute',
  components: {
    VieMap
  },
  data() {
    return {
      loading: false,
      show_map: false,
      loadingView: false,
      image: undefined,
      showImage: false,
      recordData: [],
      locations: [],
      branchs: []
    }
  },
  computed: {
    ...mapState('sale/simDistribute', [
      'resources',
      'pagination',
      'formViewData'
    ]),
    search: {
      get() {
        return this.$store.state.sale.simDistribute.search
      },
      set(newValue) {
        this.$store.commit('sale/simDistribute/SET_SEARCH', newValue)
        this.$store.commit('sale/simDistribute/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.sale.simDistribute.dateRange
      },
      set(newValue) {
        this.$store.commit('sale/simDistribute/SET_DATE_RANGE', newValue)
      }
    },
    location_id: {
      get() {
        return this.$store.state.sale.simDistribute.location_id
      },
      set(newValue) {
        this.$store.commit('sale/simDistribute/SET_LOCATION_ID', newValue)
      }
    },
    branch_id: {
      get() {
        return this.$store.state.sale.simDistribute.branch_id
      },
      set(newValue) {
        this.$store.commit('sale/simDistribute/SET_BRANCH_ID', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('simDistribute.branch') },
        { name: this.$t('simDistribute.warehourse') },
        { name: this.$t('simDistribute.serialNo') },
        { name: this.$t('simDistribute.simNo') },
        { name: this.$t('simDistribute.idType') },
        { name: this.$t('simDistribute.idNumber') },
        { name: this.$t('simDistribute.idName') },
        { name: this.$t('simDistribute.idSex') },
        { name: this.$t('simDistribute.address') },
        { name: this.$t('simDistribute.gisLocation') },
        { name: this.$t('simDistribute.photo') }
      ]
    }
  },
  async created() {
    this.branch_id = [this.$store.state.authUser.user.default_branch.branch_id]
    this.getBranch()
    this.changeBranch()
    this.location_id = [
      this.$store.state.authUser.user.default_location.location_id
    ]
  },
  methods: {
    getBranch() {
      this.loading = true
      this.$store
        .dispatch('security/user/getBranchAssignedForFilter')
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async changeBranch() {
      this.loading = true
      this.location_id = []
      await this.$store
        .dispatch('security/user/getWarehouseAssignedForFilter', {
          branch_id: this.branch_id
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('sale/simDistribute/fetch', { ...attributes })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onShowImage(row) {
      this.image = row.photo
      this.showImage = true
    },
    vieMap() {
      this.loadingView = true
      this.$store
        .dispatch('sale/simDistribute/getFormViewData', {
          params: {
            fnName: 'simSerialProfile',
            branch_id: this.branch_id,
            location_id: this.location_id,
            search: this.search,
            date_between: this.dateRange
          }
        })
        .then(response => {
          this.recordData = response.data.simSerialProfile
        })
        .finally(() => {
          this.show_map = true
          this.loadingView = false
        })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500),
    location_id: debounce(function() {
      this.fetchData(this.search)
    }, 500)
  }
}
</script>
<style scoped>
.full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }
  .ant-modal-body {
    flex: 1;
  }
}
</style>
